export default "__VITE_ASSET__ee1bda45__"